import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

// import { darken } from "@material-ui/core/styles/colorManipulator";

import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
// import Accordion from "@material-ui/core/Accordion";
// import AccordionSummary from "@material-ui/core/AccordionSummary";
// import AccordionDetails from "@material-ui/core/AccordionDetails";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// import useMediaQuery from "@material-ui/core/useMediaQuery";

import DashboardIcon from "@material-ui/icons/Dashboard";
// import DescriptionIcon from "@material-ui/icons/Description";
// import ExploreIcon from "@material-ui/icons/Explore";
import HelpIcon from "@material-ui/icons/Help";
// import HomeIcon from "@material-ui/icons/Home";
// import ListIcon from "@material-ui/icons/List";
// import LocationOnIcon from "@material-ui/icons/LocationOn";
// import MapIcon from "@material-ui/icons/Map";
// import PeopleIcon from "@material-ui/icons/People";
// import SearchIcon from "@material-ui/icons/Search";
// import SettingsIcon from "@material-ui/icons/Settings";
// import ViewListIcon from "@material-ui/icons/ViewList";
// import WarningIcon from "@material-ui/icons/Warning";
// import MoreIcon from "@material-ui/icons/MoreVert";

// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// @ts-ignore
import {
  Root,
  Header,
  Sidebar,
  Content,
  Footer,
  // CollapseBtn,
  // CollapseIcon,
  SidebarTrigger,
  SidebarTriggerIcon,
  // @ts-ignore
} from "@mui-treasury/layout";

// @ts-ignore
import {
  defaultLayoutPreset,
  // standardLayoutPreset,
  // fixedLayoutPreset,
  // contentBasedLayoutPreset,
  // cozyLayoutPreset,
  // muiTreasuryPreset
  // @ts-ignore
} from "@mui-treasury/layout/presets";

import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";

import BrandFooter from "./brand-footer";

import { useAuth } from "./use-auth";

import { useApolloClient } from "@apollo/client";

import { theme } from "./theme";

import { ReactComponent as AdconLogo } from "./ADCON_Logo_white.svg";
// import { ReactComponent as OttHydrometLogo } from "./OTT_HydroMet_Logo_white.svg";

import banner from "./banner.png";

import Options from "./components/livedata/options";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // "@global": {
    //   body: {
    //     // backgroundColor: theme.palette.common.white,
    //     backgroundColor: darken(theme.palette.background.default, 0.1),
    //   },
    // },
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    },
    grow: {
      flexGrow: 1,
    },
    // toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    footer: {
      flexGrow: 0,
      padding: theme.spacing(1),
    },
    // paddingLeft: {
    //   paddingLeft: theme.spacing(1),
    // },
    // paddingRight: {
    //   paddingRight: theme.spacing(1),
    // },
  })
);

interface Props {
  drawerContent?: JSX.Element;
  children: any;
}

function DrawerLayout(props: Props) {
  const { children /*, drawerContent*/ } = props;
  const classes = useStyles(props);
  const history = useHistory();
  const location = useLocation();
  // const sidebarStyles = useSidebarStyles();
  // const headerStyles = useHeaderStyles();

  const { signedIn, signOut } = useAuth();
  const client = useApolloClient();

  async function handleSignOut(event?: any) {
    if (event) {
      event.preventDefault();
    }
    history.replace("/");
    // history.push(`/`);
    await signOut();
    await client.resetStore();
    window.location.reload();
  }

  return (
    <div className={classes.root}>
      <Root theme={theme} config={defaultLayoutPreset}>
        {({
          headerStyles,
          sidebarStyles,
          collapsed,
          opened,
          setOpened,
        }: any) => (
          <>
            <Header>
              <AppBar position="static">
                <Toolbar variant="dense">
                  {/* <CollapseBtn
                    component={IconButton}
                    className={headerStyles.leftTrigger}
                  >
                    <CollapseIcon />
                  </CollapseBtn> */}
                  <SidebarTrigger
                    className={headerStyles.leftTrigger}
                    color="inherit"
                  >
                    <SidebarTriggerIcon />
                  </SidebarTrigger>
                  {!location.pathname.includes("livedata") && (
                    <>
                      <AdconLogo
                        height={43}
                        // className={classes.paddingRight}
                      />
                      <Typography variant="h6" color="inherit" noWrap>
                        <b>Mobile</b>View
                      </Typography>
                    </>
                  )}
                  {location.pathname.includes("livedata") && (
                    <>
                      <Typography variant="h6" color="inherit" noWrap>
                        <b>Live</b>Data
                      </Typography>
                    </>
                  )}
                  <div className={classes.grow} />
                  {/* <IconButton color="inherit">
                    <Badge badgeContent={4} color="secondary">
                      <NotificationsIcon />
                    </Badge>
                  </IconButton> */}
                  {location.pathname.includes("livedata") && <Options />}
                  {!signedIn ? (
                    <Button color="inherit" component={RouterLink} to="/login">
                      Login
                    </Button>
                  ) : (
                    <Button color="inherit" onClick={handleSignOut}>
                      Logout
                    </Button>
                  )}
                  {/* <IconButton aria-label="display more actions" edge="end" color="inherit">
                    <MoreIcon />
                  </IconButton> */}
                </Toolbar>
              </AppBar>
            </Header>
            {/* <HeaderOffset /> */}
            <Content>
              <Hidden smDown>
                {/* <img
                  src={banner}
                  alt="banner"
                  style={{
                    height: "100px",
                    // width: "100%",
                    maxWidth: "100%",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto"
                  }}
                /> */}
                <div
                  style={{
                    backgroundImage: `url(${banner})`,
                    height: "100px",
                    width: "100%",
                    maxWidth: "100%",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    backgroundRepeat: "space", // TODO make configurable ("space" vs. undefined)
                    backgroundPosition: "center center", // TODO make configurable ("center" vs. undefined)
                  }}
                ></div>
              </Hidden>
              <main className={classes.content}>{children}</main>
            </Content>
            <Sidebar>
              <>
                {/* <NavHeaderEx collapsed={collapsed} /> */}
                <div className={sidebarStyles.container}>
                  <Hidden smUp>
                    <AppBar position="static">
                      <Toolbar variant="dense">
                        <AdconLogo
                          height={43}
                          // className={classes.paddingRight}
                        />
                        <Typography variant="h6" color="inherit" noWrap>
                          <b>Mobile</b>View
                        </Typography>
                      </Toolbar>
                    </AppBar>
                  </Hidden>
                  <List>
                    <ListItem
                      button
                      component={RouterLink}
                      to="/dashboard"
                      onClick={() => setOpened(false)}
                    >
                      <ListItemIcon>
                        <DashboardIcon />
                      </ListItemIcon>
                      <ListItemText primary={"Dashboards"} />
                    </ListItem>
                    {/* <ListItem button component={RouterLink} to="/stations" onClick={() => setOpened(false)}>
                        <ListItemIcon>
                          <ViewListIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Stations"} />
                      </ListItem> */}
                    {/* <ListItem
                      button
                      component={RouterLink}
                      to="/map"
                      onClick={() => setOpened(false)}
                    >
                      <ListItemIcon>
                        <LocationOnIcon />
                      </ListItemIcon>
                      <ListItemText primary={"Map"} />
                    </ListItem>
                    <ListItem
                      button
                      component={RouterLink}
                      to="/alerts"
                      onClick={() => setOpened(false)}
                    >
                      <ListItemIcon>
                        <WarningIcon />
                      </ListItemIcon>
                      <ListItemText primary={"Alerts"} />
                    </ListItem> */}
                    <ListItem
                      button
                      component={RouterLink}
                      to="/help"
                      onClick={() => setOpened(false)}
                    >
                      <ListItemIcon>
                        <HelpIcon />
                      </ListItemIcon>
                      <ListItemText primary={"Help"} />
                    </ListItem>
                  </List>
                  {/* <Accordion>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle2">LiveData</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <List>
                          <ListItem
                            button
                            component={RouterLink}
                            to="/livedata/collections/weather/map"
                            onClick={() => setOpened(false)}
                          >
                            <ListItemIcon>
                              <LocationOnIcon />
                            </ListItemIcon>
                            <ListItemText primary={"Map"} />
                          </ListItem>
                          <ListItem
                            button
                            component={RouterLink}
                            to="/livedata/collections/weather/list"
                            onClick={() => setOpened(false)}
                          >
                            <ListItemIcon>
                              <ViewListIcon />
                            </ListItemIcon>
                            <ListItemText primary={"List"} />
                          </ListItem>
                        </List>
                      </AccordionDetails>
                    </Accordion> */}
                </div>
                {/* <CollapseBtn className={sidebarStyles.collapseBtn}>
                <CollapseIcon />
              </CollapseBtn> */}
              </>
            </Sidebar>
            <Footer className={classes.footer}>
              <BrandFooter />
            </Footer>
          </>
        )}
      </Root>
    </div>
  );
}

export default DrawerLayout;
